import React from 'react';
import { Home } from 'lucide-react';
export function Navbar() {
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100" data-id="element-104">
      <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-105">
        <div className="flex items-center gap-2 font-bold text-xl tracking-tight text-gray-900" data-id="element-106">
          <div className="w-8 h-8 bg-brand-600 rounded-lg flex items-center justify-center text-white" data-id="element-107">
            <Home size={18} strokeWidth={2.5} data-id="element-108" />
          </div>
          MINGA
        </div>
        <button className="text-sm font-medium text-white bg-brand-600 hover:bg-brand-700 px-4 py-2 rounded-full transition-colors" data-id="element-109">
          Agendar diagnóstico gratuito
        </button>
      </div>
    </nav>;
}